import request from '@/utils/request'

// 查询企业微信-外部群聊列表
export function listChat(query) {
    return request({
        url: '/wxCp/chat/list',
        method: 'get',
        params: query
    })
}

// 查询企业微信-外部群聊详细
export function getChat(chatId) {
    return request({
        url: '/wxCp/chat/' + chatId,
        method: 'get'
    })
}

// 新增企业微信-外部群聊
export function addChat(data) {
    return request({
        url: '/wxCp/chat',
        method: 'post',
        data: data
    })
}

// 修改企业微信-外部群聊
export function updateChat(data) {
    return request({
        url: '/wxCp/chat/update',
        method: 'post',
        data: data
    })
}

// 删除企业微信-外部群聊
export function delChat(chatId) {
    return request({
        url: '/wxCp/chat/delete/' + chatId,
        method: 'post'
    })
}
